// Reusable landscape (6x4) warehouse bin/location address label (bold location code + barcode
// with caption).
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomWarehouseAddressLabelFileDataSchema = yup.object().shape({
  addressLabel: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
  barcodeText: yup.string().nullable().optional(),
})

export type BiomWarehouseAddressLabelFileData = yup.InferType<
  typeof biomWarehouseAddressLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomWarehouseAddressLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomWarehouseAddressLabelFileMappings: RequiredFileData = {
  addressLabel: '220c58c0-a0c9-4444-bb60-cc6f7c1267e0',
  barcode: '23805014-0b95-48d6-bf9f-e8740f511043',
  barcodeText: '4dc8e93f-0925-4574-a3e0-b8daf0383980',
}
